'use client';

import type { ApolloError } from '@apollo/client/errors';
import Refresh from '@crehana/compass.icons.outline/Refresh';
import { useEffect } from 'react';

import { useTranslation } from './hooks';

type TInternalErrorPIDProps = {
  error: (Error & { digest?: string }) | ApolloError | string;
  reset: () => void;
};

export const ErrorPid = ({ error, reset }: TInternalErrorPIDProps) => {
  const { t } = useTranslation();
  useEffect(() => {
    console.error(error);
  }, [error]);

  const img =
    'https://crehana-vercel-images-prd.imgix.net/public/PID/06651724-8d8e-4a0a-8e46-13864dd651a3-pageerrorpid.png?auto=format&fit=clip';

  return (
    <div className=" tw-flex tw-py-0 tw-px-4 tw-items-center tw-justify-center tw-rounded-0.8 tw-bg-neutral-light-100 tw-shadow-01 tw-h-full tw-w-full">
      <div className="tw-inline-block">
        <div>
          <div className="tw-flex  tw-justify-center tw-items-center">
            <img src={img} className="tw-w-[15.2rem]" alt="page-zero" />
          </div>
        </div>
        <div className="tw-flex tw-justify-center tw-items-center tw-pt-2.4">
          <span className="tw-font-subtitle4 tw-text-neutral-light-800 tw-mb-1.2">
            {t('TITLE_PAGE_ZERO')}
          </span>
        </div>
        <div className="tw-flex tw-justify-center tw-items-center">
          <span className="tw-font-body4 tw-text-neutral-light-700">
            {t('DESCRIPTION_PAGE_ZERO')}
          </span>
        </div>
        <div className="tw-flex tw-justify-center tw-items-center tw-mt-2.4">
          <button
            type="button"
            onClick={() => reset()}
            className="tw-btn-primary-m tw-btn-icon"
          >
            <Refresh size={24} />
            {t('BUTTON_PAGE_ZERO')}
          </button>
        </div>
      </div>
    </div>
  );
};
